import { KeyboardArrowDown, KeyboardArrowUp } from '@project-lary/react-material-symbols';
import { useState } from 'react';
import { cn } from '../utils/tailwind-merge';
import { Button, ButtonSize, ButtonVariant } from './button';
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem } from './command';
import { Popover, PopoverContent, PopoverTrigger } from './popover';

export interface SelectItem {
  label: string;
  value: string;
}

export interface SelectWithSearchProps {
  items: SelectItem[];
  selectedItem: SelectItem | undefined;
  placeholder?: string;
  onChange: (newSelectedItem: SelectItem) => void;
  disabled?: boolean;
  classNames?: string;
}

function SelectWithSearch({ items, selectedItem, placeholder, onChange, disabled, classNames }: SelectWithSearchProps) {
  const [open, setOpen] = useState(false);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild className="w-full">
        <Button
          variant={ButtonVariant.surface_neutral}
          size={ButtonSize.l}
          role="combobox"
          aria-expanded={open}
          className={cn(
            'w-full border-neutral-alpha-7 bg-white font-medium text-neutral-12 text-sm antialiased hover:border-neutral-alpha-8 active:bg-neutral-alpha-3 disabled:border-neutral-alpha-9 disabled:bg-neutral-alpha-6 disabled:opacity-50 [&>*]:w-full',
            classNames,
          )}
          disabled={disabled}
          Icon={open ? KeyboardArrowUp : KeyboardArrowDown}
          iconPosition="right"
        >
          <div>{selectedItem?.label ?? placeholder}</div>
        </Button>
      </PopoverTrigger>
      <PopoverContent className="p-0" align="start">
        <Command>
          <CommandInput placeholder="Suchen..." />
          <CommandEmpty>Empty</CommandEmpty>
          <CommandGroup>
            {items.map((item) => {
              const isSelected = selectedItem?.value === item.value;
              return (
                <CommandItem
                  key={item.value}
                  value={item.label}
                  onSelect={() => {
                    onChange(item);
                    setOpen(false);
                  }}
                  className={cn('my-1 cursor-pointer border-transparent border-l-[3px] pl-2', {
                    'border-accent-9 bg-accent-alpha-3 aria-selected:bg-accent-alpha-3': isSelected,
                  })}
                >
                  {item.label}
                </CommandItem>
              );
            })}
          </CommandGroup>
        </Command>
      </PopoverContent>
    </Popover>
  );
}

export default SelectWithSearch;
